import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private auth: AuthService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

      let token = this.auth.getToken();
    
      if (token && token.trim() != '') {
        request = request.clone(
          {
            headers: request.headers.set('Authorization', 'Bearer ' + token)
            //  .set("X-test-distribution", 'true')
          }
        );
      }

      return next.handle(request);
    }
}